export const formatCurrency = (value, currency = "INR") => {
  let numericValue = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(numericValue) || numericValue == null) {
    numericValue = 0;
  }
  let formattedValue = numericValue.toFixed(2);
  const currencySymbols = {
    INR: "₹",
    USD: "$",
    EUR: "€",
    // Add more currency symbols as needed
  };
  let currencySymbol = currencySymbols[currency] || currencySymbols["INR"];
  return `${currencySymbol}${formattedValue}`;
};
